import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  Button,
} from "reactstrap";
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import { useRecoilState } from "recoil";
import authState from "../../atom/auth";
import { login } from "../../api/auth";
import ResultHandler from "../../components/ResultHandler";
import logo from "../../assets/images/QN-logo-mini.png";
import useCustomValidation from "../dashboard/validationSchema";
import { useTranslation } from "react-i18next";
import { handleLoginSuccess } from "../../utils/handleLoginSuccess";
import tFA from "../../atom/tFA";

const Login = () => {
  const { t } = useTranslation();
  const { loginSchema } = useCustomValidation();
  const [isLogged, setIsLogged] = useRecoilState(authState);
  const [tFAMandatory, setTFAMandatory] = useRecoilState(tFA);
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: localStorage.getItem("email"),
      password: localStorage.getItem("password"),
    },
    validationSchema: loginSchema,
    onSubmit: (values) => {
      setLoading(true);
      let email = values.email;
      let password = values.password;

      login({ email, password })
        .then(({ data }) => {
          setTFAMandatory(data.data.tFAMandatory);
          localStorage.setItem(
            "twoFactorEnabled",
            data.data.admin.twoFactorEnabled
          );

          if (data.data.admin.twoFactorEnabled) {
            history.push("/login-two-factor-authintication", {
              authenticity_token: data.data.authenticity_token,
            });
          } else {
            setIsLogged(true);
            setLoading(false);
            handleLoginSuccess(data.data, history);
          }
        })
        .catch((err) => {
          console.log(err);
          setError(err.response.data.message);
          setLoading(false);
        });
    },
  });

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container className="pt-5">
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className=" login-box">
                <CardBody className="pt-4">
                  <div>
                    <Link to="/" className="auth-logo-light">
                      <div
                        className="avatar-md profile-user-wid mt-0"
                        style={{
                          position: "absolute",
                          top: "0px",
                          transform: "translate(-50%, -50%)",
                          left: "50%",
                        }}
                      >
                        <span
                          className="avatar-title rounded-circle"
                          style={{ backgroundColor: "#f8f8fb" }}
                        >
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">{t("forms.Email")}</Label>
                        <Input
                          name="email"
                          className="form-control"
                          type="email"
                          placeholder="Enter Email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">
                          {t("forms.Password")}
                        </Label>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                              ? true
                              : false
                          }
                        />
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-4 d-flex flex-row-reverse">
                        <Link
                          to="/forgot-password"
                          onClick={() =>
                            localStorage.setItem(
                              "email",
                              validation.values.email
                            )
                          }
                          className="text-info text-decoration-underline fw-bold"
                        >
                          Forgot Your Password ?
                        </Link>
                      </div>

                      <div className="d-grid">
                        <ResultHandler error={error} />
                        {loading && (
                          <Button type="button">
                            <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>{" "}
                            {t("login.loading")}
                          </Button>
                        )}
                        {!loading && (
                          <Button color="primary" type="submit">
                            {t("login.login")}
                          </Button>
                        )}
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Login;
